import { CHAT_MESSAGE_DIRECTIONS } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const ChatsTableDefinitionZod = z.object({
    customerIdentity: z.string().min(1),
    id: schemaId,
    // 24h-window boundary; nullish for pre-field rows.
    lastInboundAt: z.number().nullish(),
    lastMessageAt: z.number().nullable(),
    // MessageReceived/MessageQueued only — not status events. nullish for pre-field rows.
    lastMessageDirection: z.nativeEnum(CHAT_MESSAGE_DIRECTIONS).nullish(),
    lastMessagePreview: z.string().nullish(),
    // nullish: pre-field rows omit the key. Only set when the reaction targets the current last message.
    lastMessageReactionEmoji: z.string().nullish(),
    loanRequestIds: z.array(schemaId),
    // optional: pre-field rows omit the key.
    partnerIds: z.array(schemaId).optional(),
    // Phone-shaped only (BSUID → null); used by ApplicantPhoneChanged auto-link.
    phone: z.string().min(1).nullable(),
    phoneNumberId: z.string().min(1),
    resolved: z.boolean(),
});

export type ChatsTableSchema = z.infer<typeof ChatsTableDefinitionZod>;
